import { calculator } from './PriceCalculatorService'
class CouponCalculator {
  used_Coupons = [];

  calcAllCoupons(coupons, cartItems) {

    var totalDiscount = 0;
    this.used_Coupons = [];
    coupons.forEach(coupon => {
      totalDiscount += this.calculateCouponDiscountValue(coupon, cartItems);
    });
    return totalDiscount;
  }
  calculateCouponDiscountValue(coupon, cartItems) {
    var totalDiscount = 0;
    var totalPercentDiscount = 0;
    var totalFreeDollarDiscount = 0;

    if (!this.canCouponApply(coupon, cartItems))
      return totalDiscount;
    var candidates = this.getCouponCandidates(coupon, cartItems);

    candidates.forEach(candidate => {
      totalPercentDiscount += this.calculatePercentDiscount(candidate, coupon);
      if (totalFreeDollarDiscount == 0)
        totalFreeDollarDiscount += this.calculateFreeDollarDiscount(coupon);

    });

    totalDiscount = totalFreeDollarDiscount + totalPercentDiscount;
    if (totalDiscount > 0) {
      this.used_Coupons.push(coupon.CouponCode); coupon.isUsed = true;
    }

    return totalDiscount;
  }
  getCouponCandidates(coupon, cartItems) {
    return cartItems.filter(cartItem => (
      ((!coupon.Product && (!coupon.CouponCategory || coupon.CouponCategory.length === 0)) ||
        cartItem.id + "" === coupon.Product ||
        coupon.CouponCategory.find(itm => (cartItem.ProductCategoryIDs && cartItem.ProductCategoryIDs.indexOf && cartItem.ProductCategoryIDs.indexOf(itm.ID + "") > -1)))
    ));
  }
  calculatePercentDiscount(candidate, coupon) {

    if (coupon.PercentageValue && coupon.PercentageValue <= 0)
      return 0;
    return calculator.calcItemPrice(candidate) * (coupon.PercentageValue / 100);
  }
  canCouponApply(coupon, cartItems) {
    if (!coupon || !cartItems)
      return false;
    if (cartItems.length == 0)
      return false;
    var couponMinimumSpent = coupon.MinSpent != null ? coupon.MinSpent : 0;
    if (couponMinimumSpent > 0 && calculator.calcCartPrice(cartItems) < couponMinimumSpent)
      return false;
    return true;
  }
  calculateFreeDollarDiscount(coupon) {
    if (!coupon.FreeDollar || coupon.FreeDollar <= 0)
      return 0;
    return coupon.FreeDollar;
  }

}
export const couponCalculator = new CouponCalculator();